import React from 'react';
import type { TalentSearchResponse } from '@axiom/validation';
import { IconButton, Pagination } from '@axiom/ui';

export interface TalentSearchPaginationProps {
  searchResponse: TalentSearchResponse;
}

export const TalentSearchPagination = ({
  searchResponse,
}: TalentSearchPaginationProps) => {
  const { currentPage, pageCount } = searchResponse.meta;

  const getPaginationLink = (incremental: number) => {
    const queryParams = window.location.search || '';
    let pageNumber = currentPage + incremental;
    pageNumber =
      (pageNumber < 1 && 1) ||
      (pageNumber > pageCount && pageCount) ||
      pageNumber;
    return `/browse-talent/page/${pageNumber}${queryParams}`;
  };

  return (
    <Pagination
      name="TALENT_SEARCH_PAGINATION"
      currentPage={currentPage}
      nextButton={
        <IconButton
          icon="arrow-right"
          name="pagination-next-button"
          pattern="secondary"
          to={getPaginationLink(1)}
          variation="minimal"
        />
      }
      prevButton={
        <IconButton
          icon="arrow-left"
          name="pagination-prev-button"
          pattern="secondary"
          to={getPaginationLink(-1)}
          variation="minimal"
        />
      }
      totalPages={pageCount}
    />
  );
};
